<template>
    <div class="container">
        <section class="section">
            <div class="container">
                <h1 class="title">BRAIN Initiative Archives and Programs</h1>
                <p>
                    The Brain Research Through Advancing Innovative Neurotechnologies® Initiative, or The BRAIN Initiative®, is a partnership between Federal and non-Federal entities with a common goal of accelerating the development of innovative neurotechnologies. 
                </p>
                <br />
                <p>
                    RRID:<a href="https://rrid.site/data/record/nlx_144509-1/SCR_017273/resolver?q=bossdb&l=bossdb&i=rrid:scr_017273" target="_blank" rel="noopener noreferrer">SCR_017273</a>
                    <br />
                    Archive DOI: <a href="https://doi.org/10.25504/FAIRsharing.980d94" target="_blank" rel="noopener noreferrer">10.25504/FAIRsharing.980d94</a>
                </p>
            </div>
        </section>

        <section
            class="section"
            v-for="(group, category_name) in links"
            :key="category_name"
        >
            <div class="container">
                <h2 class="title is-4">{{ category_name }}</h2>
                <div class="columns is-multiline">
                    <div
                        v-for="link in group"
                        :key="link.name"
                        class="column is-4-desktop is-6-tablet"
                    >
                        <div class="card">
                            <div class="card-content link-card">
                                <div class="media">
                                    <div class="media-left">
                                    <div v-if="link.logo" class="archive-logo-frame">
                                        <img
                                        class="archive-logo"
                                        :src="link.logo"
                                        :alt="`${link.name} logo`"
                                        loading="lazy"
                                        decoding="async"
                                        />
                                    </div>

                                    <span v-else class="icon archive-fallback-icon">
                                        <i :class="link.icon"></i>
                                    </span>
                                    </div>

                                    <div class="media-content">
                                        <div class="title is-5">
                                            <router-link
                                                v-if="link.description"
                                                :to="'/links/' + link.name"
                                            >
                                                {{ link.name }}
                                            </router-link>
                                            <a
                                                v-else
                                                :href="link.link"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {{ link.name }}
                                            </a>
                                        </div>
                                        <div class="content" v-html="link.blurb"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import links from "@/brain_initiative_links.js";
export default {
    data() {
        return { links: links.categories };
    },
};
</script>

<style>
.link-card {
    min-height: 10em;
}
.archive-logo-frame {
  width: 70px;
  height: 70px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.archive-logo {
  width: 100%;
  height: 100%;
  object-fit: contain; 
  display: block;
}

</style>